export const CATEGORY_TYPES = ['topic', 'group'];

export const LINK_TYPE_CATEGORIES = [
  {
    id: 'services',
    title: 'Services',
    path: 'all-links?linkType=service',
    type: 'topic',
    icon: 'Copy',
  },
  {
    id: 'experiences',
    title: 'Experiences',
    path: 'all-links?linkType=experience',
    type: 'topic',
    icon: 'Medal',
  },
];
